import { APP_API_BASE } from "./apiConfig";

const TOKEN_KEY = "finpilot_token";

export const getStoredToken = () => window.localStorage.getItem(TOKEN_KEY);

export const setStoredToken = (token) => {
  window.localStorage.setItem(TOKEN_KEY, token);
};

export const clearStoredToken = () => {
  window.localStorage.removeItem(TOKEN_KEY);
};

export const getAuthHeaders = () => {
  const token = getStoredToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

export const loginUser = async ({ email, password }) => {
  const response = await fetch(`${APP_API_BASE}/api/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Login failed");
  }
  return json;
};

export const registerUser = async ({ name, email, password, inviteCode }) => {
  const response = await fetch(`${APP_API_BASE}/api/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      email,
      password,
      invite_code: inviteCode,
    }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Registration failed");
  }
  return json;
};

export const fetchCurrentUser = async () => {
  const response = await fetch(`${APP_API_BASE}/api/auth/me`, {
    headers: {
      ...getAuthHeaders(),
    },
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Unable to load user");
  }
  return json.user;
};

export const updateProfile = async ({ name, email, inviteCode, currentPassword }) => {
  const response = await fetch(`${APP_API_BASE}/api/auth/profile`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ name, email, invite_code: inviteCode, current_password: currentPassword }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Profile update failed");
  }
  return json.user;
};


export const changePassword = async ({ currentPassword, newPassword }) => {
  const response = await fetch(`${APP_API_BASE}/api/auth/change-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Password change failed");
  }
  return json;
};

export const requestPasswordReset = async (email) => {
  const response = await fetch(`${APP_API_BASE}/api/auth/password-reset`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Password reset failed");
  }
  return json;
};

export const confirmPasswordReset = async ({ token, password }) => {
  const response = await fetch(`${APP_API_BASE}/api/auth/password-reset/confirm`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token, password }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Password reset failed");
  }
  return json;
};

export const createBillingCheckout = async ({ productType }) => {
  const response = await fetch(`${APP_API_BASE}/api/billing/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ product_type: productType }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Unable to create checkout");
  }
  return json;
};
